import { render } from "./StatusDetailsModal.vue?vue&type=template&id=952bc11e&scoped=true"
import script from "./StatusDetailsModal.vue?vue&type=script&lang=js"
export * from "./StatusDetailsModal.vue?vue&type=script&lang=js"

import "./StatusDetailsModal.vue?vue&type=style&index=0&id=952bc11e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-952bc11e"]])

export default __exports__